<p>{{message_error}}</p>
<p>{{'component.leads_task.error_process_message' | translate}}</p>
<p *ngFor="let contact of already_processed_contacts">
    {{contact}}
</p>